// 页数从0开始，目前应该只适用于page_ctx为page_ctx: "from=18&size=18"形式的参数
// 其中from后面的参数 18 代表 第一页 1 * 每页的size 18,
// 方法中的参数pageCtxValStr只会匹配${pageIdx}将其替换为对应的参数值curPage * pageSize
// 如果你的参数是页数，不是curPage * pageSize，那么后面的size可以写死，传入的pageSize请改为 1
// note: pageIdx从0开始，0页的上一页为 -1，这个方法里指定了当前页数为0时，上一页为-1，不发请求
// 当前页面数据上下一页参数需可计算，不可计算的无法获取上一页数据，所以必须是page和pageSize才可使用该方法
// class MultiPagePreReq {
//   constructor({
//     defaultData,
//     beforeFirstPage, // 如果第一页是0,那么这个值是-1，如果是第一页是1，那么这个值是0
//     // curPage,
//     pageCtxKeyStr, // 关于第几页参数的key值，需要为字符串
//     pageCtxValStr, // 关于第几页参数的value值，需要为字符串，将curPage内容替换掉该字符串中的页数信息内容
//     // otherParams, // 除了页数参数外的其他参数
//     // stableBody, // 参数为后台返回的，并找不到规律，无法进行替换的，不会预加载，只会返回当前参数请求回来的参数
//     requestFunc, // 发送请求的函数
//     handleDataFunc, // 处理请求回来数据的函数
//     updateCurPageFunc, // 更新当前面页数据函数
//   }) {
//     this.preLoadData = defaultData || { };
//     this.defaultData = defaultData || { };
//     this.pageCtxKeyStr = pageCtxKeyStr;
//     this.pageCtxValStr = pageCtxValStr;
//     this.beforeFirstPage = beforeFirstPage;
//     this.requestFunc = requestFunc || (() => { });
//     this.handleDataFunc = handleDataFunc || (() => { });
//     this.updateCurPageFunc = updateCurPageFunc || (() => { });
//     this.firstFlag = true;
//   }

//   async handleReqData({
//     body,
//     curPage,
//   }) {
//     const res = await this.requestFunc(body, {});
//     const handleData = this.handleDataFunc(res, curPage);
//     return handleData;
//   }

//   async handlePageData({
//     curPage,
//     curPageCtxValue,
//     prevPageCtvValue,
//     nextPageCtxValue,
//     pageSize,
//     otherParams,
//   }) {
//     const prevPage = curPage - 1;
//     const nextPage = curPage + 1;
//     let curPageData = this.preLoadData[curPage];
//     let prevPageData = this.preLoadData[prevPage];
//     let nextPageData = this.preLoadData[nextPage];
//     // 是否获取下一页用当前页数的数据中的hasMore来判断, handleDataFunc返回必须要这个参数
//     const hasNextPage = this.firstFlag || (curPageData && curPageData.hasMore);
//     this.firstFlag = false;
//     // 处理数据时计算添加isHaveData参数，使用时直接使用该参数不加判断，同hasMore
//     if (curPageData && curPageData.isHaveData) this.updateCurPageFunc(curPageData);
//     const body = {
//       ...otherParams,
//     };
//     if (!curPageData || !curPageData.isHaveData) {
//       body[this.pageCtxKeyStr] = curPageCtxValue || this.pageCtxValStr.replace('${pageIdx}', curPage * pageSize);
//       curPageData = await this.handleReqData({
//         body,
//         curPage,
//       });
//       this.updateCurPageFunc(curPageData);
//     }

//     if (!prevPageData || !prevPageData.isHaveData) {
//       if (prevPage <= this.beforeFirstPage) {
//         prevPageData = {
//           // pageIdx: -1,
//           // pageData: [],
//           // isHaveData: false,
//           // hasMore: true,
//         };
//       } else {
//         body[this.pageCtxKeyStr] = prevPageCtvValue || this.pageCtxValStr.replace('${pageIdx}', prevPage * pageSize);
//         prevPageData = await this.handleReqData({
//           body,
//           curPage: prevPage,
//         });
//       }
//     }

//     if (!nextPageData || !nextPageData.isHaveData) {
//       if (!hasNextPage) {
//         nextPageData = {
//           // pageIdx: nextPage,
//           // pageData: [],
//           // isHaveData: false,
//           // hasMore: true,
//         };
//       } else {
//         body[this.pageCtxKeyStr] = nextPageCtxValue || this.pageCtxValStr.replace('${pageIdx}', nextPage * pageSize);
//         nextPageData = await this.handleReqData({
//           body,
//           curPage: nextPage,
//         });
//       }
//     }

//     this.preLoadData = {};
//     this.preLoadData[prevPage] = { ...prevPageData };
//     this.preLoadData[curPage] = { ...curPageData };
//     this.preLoadData[nextPage] = { ...nextPageData };
//   };

//   async multiPagePreReq({
//     curPage,
//     pageSize, // 每页请求的数量
//     curPageCtxValue,
//     prevPageCtvValue,
//     nextPageCtxValue,
//     // pageCtxKeyStr, // 关于第几页参数的key值，需要为字符串
//     // pageCtxValStr, // 关于第几页参数的value值，需要为字符串，将curPage内容替换掉该字符串中的页数信息内容
//     otherParams, // 除了页数参数外的其他参数
//     stableBody, // 参数为后台返回的，并找不到规律，无法进行替换的，不会预加载，只会返回当前参数请求回来的参数
//     // requestFunc, // 发送请求的函数
//     // handleDataFunc, // 处理请求回来数据的函数
//     // updateCurPageFunc, // 更新当前面页数据函数
//   }) {
//     if (stableBody) {
//       // 固定的参数，只获取当前页数的数据
//       const res = await this.requestFunc(stableBody, {});
//       const handleData = this.handleDataFunc(res);
//       // return handleData;
//       this.updateCurPageFunc(handleData);
//     }
//     if (!this.pageCtxKeyStr || typeof (this.pageCtxKeyStr) !== 'string') return; // 这个两个参数没有无法继续发请求
//     if (!this.pageCtxValStr || typeof (this.pageCtxValStr) !== 'string') return; // 这个两个参数没有无法继续发请求
//     if (!curPage && curPage !== 0) return; // 如果没有页数信息也无法发请求
//     this.handlePageData({
//       curPage,
//       curPageCtxValue,
//       prevPageCtvValue,
//       nextPageCtxValue,
//       pageSize,
//       otherParams,
//     });
//   };

//   removeData() {
//     this.preLoadData = this.defaultData || { };
//   }
// }

// export default MultiPagePreReq;
// let preLoadData = {
//   '-1': {
//     pageIdx: -1,
//     pageData: [],
//     isHaveData: false,
//     hasMore: true,
//   },
//   0: {
//     pageIdx: 0,
//     pageData: [],
//     isHaveData: false,
//     hasMore: true,
//   },
//   1: {
//     pageIdx: 1,
//     pageData: [],
//     isHaveData: false,
//     hasMore: true,
//   },
// };

// async function handleReqData({
//   requestFunc,
//   handleDataFunc,
//   body,
// }) {
//   const res = await requestFunc(body, {});
//   const handleData = handleDataFunc(res);
//   return handleData;
// }

// const handlePageData = ({
//   curPage,
//   requestFunc,
//   handleDataFunc,
//   updateCurPageFunc,
//   otherParams,
//   pageCtxKeyStr,
//   pageCtxValStr,
// }) => {
//   const prevPage = curPage - 1;
//   const nextPage = curPage + 1;
//   let curPageData = preLoadData[curPage];
//   let prevPageData = preLoadData[prevPage];
//   let nextPageData = preLoadData[nextPage];
//   if (curPageData && curPageData.isHaveData) updateCurPageFunc(curPageData.pageData);
//   const body = {
//     ...otherParams,
//   };
//   if (!curPageData || !curPage.isHaveData) {
//     body[pageCtxKeyStr] = pageCtxValStr.replace('${pageIdx}', curPage);
//     curPageData = await handleReqData({
//       requestFunc,
//       handleDataFunc,
//       body,
//     });
//     updateCurPageFunc(handleData);
//   }

//   if (!prevPageData || !prevPageData.isHaveData) {
//     if (prevPage === -1) {
//       preLoadData[-1] = {
//         pageIdx: -1,
//         pageData: [],
//         isHaveData: false,
//         hasMore: true,
//       };
//     } else {
//       body[pageCtxKeyStr] = pageCtxValStr.replace('${pageIdx}', prevPage);
//       prevPageData = await handleReqData({
//         requestFunc,
//         handleDataFunc,
//         body,
//       });
//     }
//   }

//   if (!nextPageData || !nextPageData.isHaveData) {
//     if (!curPageData.hasMore) {
//       preLoadData[nextPage] = {
//         pageIdx: nextPage,
//         pageData: [],
//         isHaveData: false,
//         hasMore: true,
//       };
//     } else {
//       body[pageCtxKeyStr] = pageCtxValStr.replace('${pageIdx}', nextPage);
//       nextPageData = await handleReqData({
//         requestFunc,
//         handleDataFunc,
//         body,
//       });
//     }
//   }

// };

// const multiPagePreReq = ({
//   curPage,
//   pageCtxKeyStr, // 关于第几页参数的key值，需要为字符串
//   pageCtxValStr, // 关于第几页参数的value值，需要为字符串，将curPage内容替换掉该字符串中的页数信息内容
//   otherParams, // 除了页数参数外的其他参数
//   stableBody, // 参数为后台返回的，并找不到规律，无法进行替换的，不会预加载，只会返回当前参数请求回来的参数
//   requestFunc, // 发送请求的函数
//   handleDataFunc, // 处理请求回来数据的函数
//   updateCurPageFunc, // 更新当前面页数据函数
// }) => {
//   if (stableBody) {
//     // 固定的参数，只获取当前页数的数据
//     const res = await requestFunc(stableBody, {});
//     const handleData = handleDataFunc(res);
//     return handleData;
//   }
//   if (!pageCtxKeyStr || typeof (pageCtxKeyStr) !== 'string') return; // 这个两个参数没有无法继续发请求
//   if (!pageCtxValStr || typeof (pageCtxValStr) !== 'string') return; // 这个两个参数没有无法继续发请求
//   if (!curPage && curPage !== 0) return; // 如果没有页数信息也无法发请求
//   handlePageData({
//     curPage,
//     requestFunc,
//     handleDataFunc,
//     updateCurPageFunc,
//     otherParams,
//     pageCtxKeyStr,
//     pageCtxValStr,
//   });
// };

import Event, { EVENTS } from './event';

export const STOREKEYS = {
  FILTER_PAGE_ALL_DATA: 'filterPage-allData',
};

// 将分页请求请求到的所有数据存入sessionStorage中，使用时取出部分需要的数据更新页面state，渲染页面
class SaveAllButGetSome {
  allDataLength;
  trueAllDataLength;
  endStartIdx;
  trueEndStartIdx;
  isRequesting;
  constructor({
    otherParams, // 除了page_ctx会随请求改变之外其他参数都不变的接口可以传这个，与handleParams方法配合使用
    handleParams, // 处理page_ctx
    preLoad, // 预加载个数
    pageCtxKeyStr, // 必传(page_ctx的key值)
    pageCtx, // 初始化时的请求信息
    storeKeys, // 数据存在sessionStorage中，是个对象，对象中的该key值下是对应的数据
    requestFunc, // 请求API，必传，发请求，目前发请求传入的参数格式是 body, {}
    handleResData, // 处理请求回来的数据,必传,将会接受的参数(setHasMorePage,setPageCtx,setAllDataLength,saveData,resData)
    endStartIdx, // 当前页面展示数据结束的索引值
    allDataLength,
    hasNextPage,
  }) {
    // this.interceptStart = 0;
    // this.interceptEnd = 0;
    this.firstEnter = true;
    this.hasNextPage = hasNextPage || false;
    this.otherParams = otherParams || {};
    this.pageCtxKeyStr = pageCtxKeyStr || '';
    this.pageCtx = pageCtx || '';
    this.storeKeys = storeKeys || '';
    this.preLoad = preLoad || 36; // 这里的默认值采取的是filterPage页面的值
    this.requestFunc = requestFunc || (() => { });
    this.handleParams = handleParams || (() => {
      try {
        const body = { ...this.otherParams };
        if (this.pageCtxKeyStr) {
          body[this.pageCtxKeyStr] = this.pageCtx;
        }
        return body;
      } catch (_e) {
        return {};
      }
    });
    this.handleResData = handleResData;
    this.endStartIdx = endStartIdx || 18;
    this.trueEndStartIdx = endStartIdx || 18;
    this.allDataLength = allDataLength || 0;
    this.trueAllDataLength = allDataLength || 0;
  }

  static sessionStorageKey = 'saveAll-but-getSome';
  // 保存数据，将处理后的数据保存在sessionStorage中
  saveData(allData) {
    let curData = this.getSaveData();
    curData = curData ? curData : {};
    curData[this.storeKeys] = allData;
    sessionStorage.setItem(this.constructor.sessionStorageKey, JSON.stringify(curData));
  }
  // 取数据，将sessionStorage中的数据全部取出使用
  getSaveData() {
    try {
      const curData = JSON.parse(sessionStorage.getItem(this.constructor.sessionStorageKey));
      if (curData) return curData;
      return null;
    } catch (_e) {
      return null;
    }
  }
  // 取数据，只取出当前接口存储的数据
  getCurSaveData() {
    try {
      const curData = JSON.parse(sessionStorage.getItem(this.constructor.sessionStorageKey));
      if (curData && curData[this.storeKeys]) {
        // 将取出的数据通过传入的该函数按照你想要的结构取出
        return curData[this.storeKeys];
        // return this.getToPageFunc(curData[this.storeKeys]);
      };
      return null;
    } catch (_e) {
      return null;
    }
  }
  // 移除sessionStorage中的数据
  removeSaveData() {
    this.saveData(null);
  }
  // 发异步请求，是否发送使用者进行控制，不会自动触发
  async requestData({
    body: acceptBody, // 可传可不传，如果有，直接拿这个body发请求，不使用handleParams函数
    pageCtx, // 可传可不传，不传则使用this.pageCtx, this.pageCtx以及this.pageCtxKeyStr都可以手动更改
    pageCtxKeyStr, // 可传可不传，不传则使用this.pageCtxKeyStr
  }) {
    if (this.isRequesting) return;
    this.isRequesting = true;
    if (this.hasNextPage) {
      try {
        let resData;
        if (acceptBody) {
          resData = await this.requestFunc(acceptBody, {});
        } else {
          const body = this.handleParams(pageCtx, pageCtxKeyStr);
          resData = await this.requestFunc(body, {});
        }
        this.handleResData({
          resData,
          setHasNextPage: this.setHasNextPage.bind(this),
          setPageCtx: this.setPageCtx.bind(this),
          setAllDataLength: this.setAllDataLength.bind(this),
          saveData: this.saveData.bind(this),
          getCurSaveData: this.getCurSaveData.bind(this),
          setIsRequesting: this.setIsRequesting.bind(this),
          setEndStartIdx: this.setEndStartIdx.bind(this),
        });
      } catch (_e) {
        if (this.firstEnter) {
          this.firstEnter = false;
          Event.emit(EVENTS.PRELOAD_FIRSTLOAD);
        }
        console.log(_e, 'error');
        this.isRequesting = false;
        // this.setIsRequesting(false);
        // 获取数据失败
        console.log('request error');
        // this.requestData({});
      }
    } else {
      this.isRequesting = false;
    }
  }

  setIsRequesting(isRequesting) {
    this.isRequesting = isRequesting;
  }

  setOtherParams(otherParams) {
    this.otherParams = otherParams;
  }

  setPreLoad(preLoad) {
    this.preLoad = preLoad;
  }

  setPageCtxKeyStr(pageCtxKeyStr) {
    if (pageCtxKeyStr && typeof (pageCtxKeyStr) === 'string') {
      this.pageCtxKeyStr = pageCtxKeyStr;
    } else {
      console.log('pageCtxKeyStr需要是一个字符串');
    }
  }

  setPageCtx(pageCtx) {
    this.pageCtx = pageCtx;
  }

  setAllDataLength(allDataLength) {
    this.trueAllDataLength = allDataLength;
    this.allDataLength = allDataLength;
  }

  setEndStartIdx(endStartIdx) {
    this.trueEndStartIdx = endStartIdx;
    this.endStartIdx = endStartIdx;
  }

  set trueAllDataLength(allDataLength) {
    this.allDataLength = allDataLength;
    if (this.endStartIdx + this.preLoad > allDataLength) {
      this.requestData({});
    }
    const flag = (this.firstEnter && allDataLength >= this.endStartIdx)
      || (this.firstEnter && !this.hasNextPage);
    if (flag && this.getCurSaveData) {
      this.firstEnter = false;
      Event.emit(EVENTS.PRELOAD_FIRSTLOAD);
    }
  }

  set trueEndStartIdx(endStartIdx) {
    this.endStartIdx = endStartIdx;
    if (endStartIdx + this.preLoad > this.allDataLength) {
      this.requestData({});
    }
  }

  setHasNextPage(hasNextPage) {
    this.hasNextPage = hasNextPage;
  }

  setFirstEnter(firstEnter) {
    this.firstEnter = firstEnter;
  }
}

export default SaveAllButGetSome;
